import { render } from "./BarChartNewA.vue?vue&type=template&id=9b404ffa&scoped=true"
import script from "./BarChartNewA.vue?vue&type=script&lang=ts"
export * from "./BarChartNewA.vue?vue&type=script&lang=ts"

import "./BarChartNewA.vue?vue&type=style&index=0&id=9b404ffa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b404ffa"

export default script